module.exports = __webpack_public_path__ + "img/ranger-front.8141d88c.jpg";